import salesOfficerRefresh from './sales_officer_refresh';
export default function app(user) {
  // console.log('hiii')
  return (dispatch) => {
    // TODO: Move DOM operations from action creator to component
    setTimeout(() => {
      const $splashLogoEl = document.getElementById('splash-logo');
      $splashLogoEl.parentElement.removeChild($splashLogoEl);

      dispatch(appMountStart());
    }, 400);
    dispatch(salesOfficerRefresh(user));
  };
}

function appMountStart() {
  return {
    type: 'app/mounted',
    payload: {},
  };
}
